import { render, staticRenderFns } from "./OrderDetailsMobileView.vue?vue&type=template&id=35a38e2c&"
import script from "./OrderDetailsMobileView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsMobileView.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsMobileView.vue?vue&type=style&index=0&id=35a38e2c&prod&sccoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports